import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { UsuariosService } from '../_services/usuarios.service'
import { AutentificacionService } from '../_services/autentificacion.service'
import { Http, Headers, Response, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/toPromise'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { SeguridadService } from '../_services/seguridad.service'

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

@Component({
  selector: 'login-form',
  templateUrl: 'login.template.html'
})
export class LoginComponent  implements OnInit, OnDestroy {

  v_error: string = "";
  accion: string = "";
  subscription: Subscription;

  constructor(private router:Router,
              private activatedRoute: ActivatedRoute,
              private usuario: UsuariosService,
              private http: Http,
              private autentificacion: AutentificacionService,
              private globalEventsManager: GlobalEventsManager,
              private seguridad: SeguridadService){

  }

  ngOnDestroy(){
    if (this.accion == "logado"){
      this.subscription.unsubscribe();
    }
  }

  ngOnInit(){

    //sacamos la acción
    this.accion = this.activatedRoute.snapshot.params["accion"];

    this.globalEventsManager.showNavBar(false);
    this.globalEventsManager.menuExtendido(true);
    let breadcrumb: any = [];

    this.globalEventsManager.setNombrePagina(breadcrumb);
    this.globalEventsManager.getNombreUsuario();

    //console.log("entro login");

    if (this.accion == "cerrarsesion"){

      this.logOut();

    }else if(this.accion == "logado"){
      this.seguridad.getLogado();

      this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
              if (mode !== null) {
                //console.log("ET login: "+mode);
                if (!mode){
                  this.router.navigate(['login']);
                  this.globalEventsManager.getNombreUsuario();
                }else{
                  this.globalEventsManager.showNavBar(true);
                  this.globalEventsManager.getNombreUsuario();
                  this.router.navigate(['inicio', 'bienvenida']);
                }
              }
          });
    }else{

      //compruebo si estoy logado y en caso de ser que sí lanzo el Inicio
      let userToken : string = localStorage.getItem('currentUserToken');
      if (userToken){
        //si hay token miramos si está caducado o no
        this.autentificacion.isLoginActive(userToken).subscribe(
                    data => {

                        let user = data;
                        let error = user.error; //almacenamos el parámetro error
                        let numerrores = Object.keys(error).length; // miramos si llega vacío

                        if (numerrores == 0){ //si ha caducado no muestro el menú
                          //console.log("sesion activa");
                          this.globalEventsManager.showNavBar(true);
                          this.globalEventsManager.getNombreUsuario();
                          this.router.navigate(['inicio', 'bienvenida']);
                        }else{
                          //console.log("ha caducado, estoy en login");
                          this.autentificacion.logout();
                        }

                    },
                    error => {
                        console.log("error login isLoginActive");
                    });


        //this.router.navigate(['inicio']);
      }

    }


  }

  login(formulario:NgForm){

    var user: any;
    var v_usuario: string;
    var v_contrasena: string;

    //estos dos campos vienen del formulario html
    v_usuario = formulario.controls['usuario'].value;
    v_contrasena = formulario.controls['contrasena'].value;

    this.autentificacion.loginAuth(v_usuario, v_contrasena).subscribe(
                data => {

                    user = data;
                    let error = user.error; //almacenamos el parámetro error
                    let numerrores = Object.keys(error).length; // miramos si llega vacío

                    if (numerrores == 0){
                      this.globalEventsManager.showNavBar(true);
                      this.globalEventsManager.getNombreUsuario();
                      this.router.navigate(['/inicio/bienvenida/']);// login/logado/ en caso de bucle //recargamos login para irnos al inicio
                    }else{
                      this.v_error = error.errormsg; //para sacar el error por pantalla
                    }


                },
                error => {
                    //console.log(error);
                    console.log("error login");
                });

  }

  logOut(){
    this.autentificacion.logout().subscribe(
      data => {
        this.globalEventsManager.getNombreUsuario();
        this.router.navigate(['login']);
      }
    );

  }


}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts